import { render, staticRenderFns } from "./Personas.vue?vue&type=template&id=f6541f56"
import script from "./Personas.vue?vue&type=script&lang=js"
export * from "./Personas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports